module.exports = __webpack_public_path__ + "img/Frame-56.ef7496ed.svg";